import Box from '@mui/material/Box';

import useStyles from 'components/MenuMakeImport/Stepper/styles';

interface StepperStartTextProps {
  children: React.ReactNode;
}

export function StepperStartText({ children }: StepperStartTextProps) {
  const classes = useStyles();
  return <Box className={classes.stepperDescription}>{children}</Box>;
}

export default StepperStartText;
